<script>
  export let location;  // implicitly populated by router
</script>

<div class="static-content">
  <h3>Privacy Policy</h3>

  <p>
    Run-A-Relay ("RaR") does not set cookies on your device.
  </p>

  <p>
    Only severe TCP, HTTP, and TLS errors are logged.  These logs may
    inadvertently contain visitor IP addresses.
  </p>

  <p>
    SSH connections made to port 22 on RunARelay.org do <em>not</em>
    trigger logging; such connections are not logged at all.  If we
    begin to receive abuse, this may change, but only then may we store
    long-term the IPs of users attempting to overload our site with
    requests.
  </p>

  <p>
    In the future we may record <em>how many</em> visitors we receive to
    this website, but not <em>who</em>.  RaR will <em>never</em> use
    Google Analytics for this purpose, nor any other purpose.
  </p>

  <p>
    Aside from the caveats above, we store zero information about our
    users.
  </p>
</div>
